<template >
 <v-footer  class="footbar" padless>
   <v-card-text class="white--text">
  © {{ new Date().getFullYear() }} Capita Business Services Ltd. All rights reserved.</v-card-text> </v-footer>
</template>
<script>
export default {
  name: "FooterMenuBasic"
};
</script>
<style scoped>
.footbar {
  position: fixed !important;
  background-color: #02083c !important;
  width: 100%;
  bottom: 0;
}
.white--text{
  text-align: center !important;
}
</style>